import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { MiniPlayer } from './MiniPlayer';
import { LanguageSelector } from './LanguageSelector';
import { useAudioStore } from '@/hooks/useAudioStore';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { currentStation } = useAudioStore();
  const isPlayerScreen = location.pathname === '/app/player';
  const showNav = !isPlayerScreen;
  const showMiniPlayer = currentStation && !isPlayerScreen;

  // LanguageSelector na Impressum, Datenschutz i postavkama (na News je u hero headeru)
  const showLanguageSelector =
    location.pathname === '/impressum' ||
    location.pathname === '/datenschutz' ||
    location.pathname === '/app/settings';

  return (
    <div className="min-h-screen text-text-primary relative overflow-hidden">
      {showLanguageSelector && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100]">
          <LanguageSelector />
        </div>
      )}
      {/* Animated smoke background */}
      <div
        className="fixed inset-0 bg-cover bg-center bg-no-repeat bg-smoke-animated"
        style={{
          backgroundImage: 'url(/bg-smoke.png)',
          height: '115%',
          top: '-7.5%',
        }}
        aria-hidden
      />
      {/* Overlay za čitljivost sadržaja */}
      <div className="fixed inset-0 bg-primary-bg/50" aria-hidden />
      <main
        className={`relative z-10 ${isPlayerScreen ? '' : showMiniPlayer ? 'pb-36' : 'pb-24'}`}
      >
        {children}
      </main>
      <MiniPlayer />
      {showNav && <Navigation />}
    </div>
  );
};
